import React from "react";

export default function Logo() {
  return (
    <a href="/" className="kritikerlaget-logo">
      Norsk Kritikerlag
    </a>
  );
}
